// components/Hero.jsx — Full-bleed hero with 21:9 ratio background

import { Button } from "./UI";

export default function Hero({ content, lang }) {
  const isEs = lang === "es";
  const title      = isEs ? (content.titleEs      || content.title)      : content.title;
  const subtitle   = isEs ? (content.subtitleEs   || content.subtitle)   : content.subtitle;
  const ctaText    = isEs ? (content.ctaTextEs    || content.ctaText)    : content.ctaText;
  const viewWork   = isEs ? (content.viewWorkTextEs || "Ver Nuestro Trabajo ↓") : (content.viewWorkText || "View Our Work ↓");

  return (
    <div className="relative w-full overflow-hidden sm:[aspect-ratio:21/9]">
      {/* Background image */}
      <img
        src={content.bgImage}
        alt="Hero background"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: "center" }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/70 via-[#0F172A]/55 to-[#0F172A]/80" />
      <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#A3E635]/60 to-transparent" />

      {/* Content — relative so it gives height to parent on mobile */}
      <div className="relative flex flex-col items-center justify-center text-center text-white px-4 sm:px-8 py-16 sm:py-0 sm:absolute sm:inset-0">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#A3E635]/30 bg-[#A3E635]/10 px-3 py-1 text-xs font-semibold tracking-widest uppercase text-[#A3E635] mb-4 backdrop-blur-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-[#A3E635] animate-pulse" />
          {isEs ? "Estudio de Diseño Web" : "Web Design Studio"}
        </div>

        <h1 className="text-2xl sm:text-5xl md:text-6xl lg:text-7xl font-bold max-w-4xl leading-[1.1] tracking-tight mb-3 drop-shadow-xl">
          {title}
        </h1>

        <p className="text-sm sm:text-lg md:text-xl text-white/70 max-w-xl mb-6 leading-relaxed">
          {subtitle}
        </p>

        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 items-center">
          <a href={content.ctaLink}>
            <Button size="md" className="sm:size-xl shadow-2xl shadow-[#A3E635]/30 text-sm sm:text-base px-5 py-2.5 sm:px-7 sm:py-3.5">
              {ctaText}
            </Button>
          </a>
          <a href="#portfolio">
            <Button
              variant="secondary"
              size="md"
              className="border-white/30 text-white hover:border-[#A3E635] hover:text-[#A3E635] text-sm sm:text-base px-5 py-2.5 sm:px-7 sm:py-3.5"
            >
              {viewWork}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
